@if (loaderType === loaderTP.PERCENTAGE) {
    <div class="percentage">
        <div
            [ngClass]="{
                'extra-large-progress-circle': size === sizeLoader.ELARGE,
                'large-progress-circle': size === sizeLoader.LARGE,
                'medium-progress-circle': size === sizeLoader.MEDIUM,
                'small-progress-circle': size === sizeLoader.SMALL
            }"
            [style.--progress]="progressCharged"
        >
            <span class="progress-text"
                >{{ progressCharged | number: "1.0-0" }}%</span
            >
        </div>
        <span class="loading-text">Loading...</span>
    </div>
}
@if (loaderType === loaderTP.REGULAR) {
    <div [ngClass]="{
        'extra-large-loader': size === sizeLoader.ELARGE,
        'large-loader': size === sizeLoader.LARGE,
        'medium-loader': size === sizeLoader.MEDIUM,
        'small-loader': size === sizeLoader.SMALL
    }"></div>
}
